import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import VueAxios from "vue-axios";
import VueMeta from "vue-meta";
import Buefy from "buefy";
//import "buefy/dist/buefy.css";
import marked from "marked";
import VueFriendlyIframe from "vue-friendly-iframe";

Vue.config.productionTip = false;

//axios.defaults.baseURL = "https://admin.sloboziabc.org/";
axios.defaults.baseURL = "https://admin.sloboziabc.org/";

Vue.prototype.$mySite = {
  title: "SloboziaBC.org",
  url: "https://sloboziabc.com",
  shareImage: "https://sloboziabc.com/imgages/share.jpg",
  resurces: "https://admin.sloboziabc.org"
};

Vue.prototype.$locales = {
  en:{
    more: "Read More",
    donate: "Donate",
  },
  ru:{
    more: "Далее",
    donate: "Пожертвовать",
  }
};

// Lets use the code below inside a components
// Vue.marked()
// this.$marked()
Vue.use({
  install () {
    Vue.marked = marked
    Vue.prototype.$marked = marked
  }
});
Vue.use(Buefy, {
  defaultIconPack: "fas"
});
Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
});
Vue.use(VueFriendlyIframe);
Vue.use(VueAxios, axios);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
